import React from 'react';
import { useSiteMeta } from './hooks/useSiteMeta';
import { SiteNav } from './components/SiteNav';
import { Hero } from './components/Hero';
import { Proposition } from './components/Proposition';
import { Evidence } from './components/Evidence';
import { CareerJourney } from './components/CareerJourney';
import { CurrentAppointment } from './components/CurrentAppointment';
import { BoardExperience } from './components/BoardExperience';
import { BoardroomContribution } from './components/BoardroomContribution';
import { SelectedEvidence } from './components/SelectedEvidence';
import { PublicRecord } from './components/PublicRecord';
import { Credentials } from './components/Credentials';
import { Availability } from './components/Availability';
import { Contact } from './components/Contact';
export function App() {
  useSiteMeta();
  return <div id="top" className="w-full bg-ink font-sans antialiased" data-id="element-0" data-mp="28sl3uyeo7ofi">
      <SiteNav data-id="element-1" data-mp="23u9tmmkgrbwr" />
      <Hero data-id="element-2" data-mp="23ujha3i1d6za" />
      <main data-id="element-3" data-mp="23v2sz2h3ez4v">
        <Proposition data-id="element-4" data-mp="23t8eo70bu59r" />
        <Evidence data-id="element-5" data-mp="3ik7fqfdqo9q4" />
        <CareerJourney data-id="element-6" data-mp="3ikqyfyb7r257" />
        <CurrentAppointment data-id="element-7" data-mp="3ijfwm41bw4gq" />
        <BoardExperience data-id="element-8" data-mp="3ii4su47vuwpm" />
        <BoardroomContribution data-id="element-9" data-mp="3mlatmwc87vop" />
        <SelectedEvidence data-id="element-10" data-mp="3mk868ye44bdj" />
        <PublicRecord data-id="element-11" data-mp="3mjgannkimdn9" />
        <Credentials data-id="element-12" data-mp="3rc9co3oln7vn" />
        <Availability data-id="element-13" data-mp="3rbzmog3k10py" />
      </main>
      <Contact data-id="element-14" data-mp="3rcsulke91w9o" />
    </div>;
}